import BaseSportPage from '../components/shared/BaseSportPage';
export default function TableTennis() {
  return <BaseSportPage sport="table-tennis" label="Table Tennis" />;
}
